import { Section } from '../../models';
import { REGEX_CONFIG } from 'app/shared/utils/regex-utils';
import { EdgeRlRadarFieldIds, EdgeRlSectionIds } from './base-config-models';
import { MonitorSeriesNames } from '../../../location-card.constants';
import { field } from '../../core/field-schema';
import { required, pattern, min, max, maxLength, custom } from '../../core/validator-builders';
import { EdgeRlLocationCardState } from './models';
import { setFieldValueAction } from '../../actions/form-actions';
import { BasicInfoCommonFieldIds } from '../common.models';
import { ValidatorIdentifier } from '../../models/validator-identifier';

export const edgeRlRadar = (state: EdgeRlLocationCardState): Section => {
    const details = state.locationDetails && state.locationDetails.length > 0 ? state.locationDetails[0] : null;
    const settings = state.settings;
    const config = state.monitorConfiguration;

    const isSwitchMonitor = details && details.series !== MonitorSeriesNames.edgeRl;
    const isEditMode = !!details;

    const radarDevice = config?.devices?.find((d) => d.name === 'Radar');

    return {
        info: {
            id: EdgeRlSectionIds.Radar,
            title: 'ADD_EDIT.RADAR',
            displayTitle: true,
            expandable: true,
            expanded: false,
            panelClass: 'surface-combo-section',
        },
        rows: [
            {
                info: {
                    id: 'physical-offset-row',
                    panelClass: 'custom-50p',
                },
                items: [
                    field.number(EdgeRlRadarFieldIds.PhysicalOffset, 'physicalOffset', {
                        placeholder: 'ADD_EDIT.PHYSICAL_OFFSET',
                        panelClass: 'each-Item full-width',
                        placeholderSuffix: settings.depthUnit,
                        value: isEditMode && !isSwitchMonitor && radarDevice
                            ? Number(radarDevice.physicalOffset.toFixed(2))
                            : 0,
                        validators: [
                            required(),
                            pattern({
                                value: settings.isMetric
                                    ? REGEX_CONFIG.negativeWithOneDecimalPattern
                                    : REGEX_CONFIG.negativeWithTwoDecimalPattern,
                                message: settings.isMetric
                                    ? 'COMMON.EDGE_RL_PHYSICAL_OFFSET_METRIC_ERROR'
                                    : 'COMMON.EDGE_RL_PHYSICAL_OFFSET_NON_METRIC_ERROR',
                            }),
                            min({
                                value: settings.isMetric ? -12700 : -500,
                                message: settings.isMetric
                                    ? 'COMMON.EDGE_RL_PHYSICAL_OFFSET_METRIC_ERROR'
                                    : 'COMMON.EDGE_RL_PHYSICAL_OFFSET_NON_METRIC_ERROR',
                            }),
                            max({
                                value: settings.isMetric ? 12700 : 500,
                                message: settings.isMetric
                                    ? 'COMMON.EDGE_RL_PHYSICAL_OFFSET_METRIC_ERROR'
                                    : 'COMMON.EDGE_RL_PHYSICAL_OFFSET_NON_METRIC_ERROR',
                            }),
                        ],
                    }),
                ],
            },
            {
                info: {
                    id: 'manhole-depth-row',
                    panelClass: 'custom-width',
                },
                items: [
                    field.number(EdgeRlRadarFieldIds.ManholeDepth, 'manholedepth', {
                        placeholder: 'HOME.MAP.MARKER_LOCATION_DETAIL.MANHOLE_DEPTH',
                        placeholderSuffix: settings.depthUnit,
                        panelClass: 'full-width',
                        value: isEditMode ? details.manholeDepth : null,
                        validators: [
                            required(),
                            pattern({
                                value: settings.isMetric
                                    ? REGEX_CONFIG.numeric0_100000With1DecimalPlacesPattern
                                    : REGEX_CONFIG.numeric0_100000With2DecimalPlacesPattern,
                                message: settings.isMetric
                                    ? 'COMMON.EDGE_RL_MANHOLE_DEPTH_METRIC_ERROR'
                                    : 'COMMON.EDGE_RL_MANHOLE_DEPTH_NON_METRIC_ERROR',
                            }),
                            maxLength({
                                value: 50,
                            }),
                            custom({
                                identifier: ValidatorIdentifier.ManholeDepthToPipeHeightValidator,
                                message: 'COMMON.MAN_HOLE_DEPTH_PIPE_HEIGHT_ERROR',
                            }),
                        ],
                        events: {
                            onChange: (value) => [
                                setFieldValueAction({ fieldId: BasicInfoCommonFieldIds.ManholeDepth, value }),
                            ],
                        },
                    }),
                ],
            },
        ],
    };
};
